const buyNowWizard = [
    {
        selector: '[data-react="buy-now-wizard"]',
        path: { filename: 'App' },
    },
];

export { buyNowWizard };
